var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import icons from "../../utils/Icons";
import PrimaryButton from "../Button/PrimaryButton";
// import ImageThumbnail from "../ImageThumbnail";
// import images from "../../utils/Images";
import { ToastContainer, toast } from 'react-toastify';
import useAddNameToList from "../../hooks/useAddNameToList";
import Spinner from "../Spinner";
import { useDispatch, useSelector } from "react-redux";
import { updateLocalStorageAttribute, updateUserState } from "../../store/slices/userSlice";
var getPosition = function (record) {
    if (record === undefined || record.position === '' || record.position === undefined)
        return [];
    return record.position.split(',');
};
var getNoEller = function (record) {
    if (record === undefined || record.no_eller === '' || record.no_eller === undefined)
        return false;
    return record.no_eller === 1;
};
var getIsSfct = function (record) {
    if (record === undefined || record.no_sfct === '' || record.no_sfct === undefined)
        return false;
    return record.no_sfct === 1;
};
var getIsNoSmallBoat = function (record) {
    if (record === undefined || record.no_smallboat === '' || record.no_smallboat === undefined)
        return false;
    return record.no_smallboat === 1;
};
export var positions = [
    { key: '', value: ' Position' },
    { key: 'MULE DRIVER', value: 'MULE DRIVER' },
    { key: 'TOP LOADER', value: 'TOP LOADER' },
    { key: 'FORK LIFT', value: 'FORK LIFT' },
    { key: 'SHIP FLAG', value: 'SHIP FLAG' },
    { key: 'GROUND FLAG', value: 'GROUND FLAG' },
    { key: 'LANDER', value: 'LANDER' },
    { key: 'TOPMAN', value: 'TOPMAN' },
    { key: 'LABORER', value: 'LABORER' },
    { key: 'PORTER', value: 'PORTER' },
    { key: 'PALLET JACK', value: 'PALLET JACK' },
    { key: 'GANTRY CRANE', value: 'GANTRY CRANE' },
    { key: 'MOBILE CRANE', value: 'MOBILE CRANE' },
    { key: 'RTG', value: 'RTG' }
];
var AddNameToListModal = function (_a) {
    var closeModal = _a.closeModal, addNameHandle = _a.addNameHandle, existingUser = _a.existingUser;
    var dispatch = useDispatch();
    var modalRef = useRef(null);
    var userId = useSelector(function (state) { return state.user.userId; });
    var _b = React.useState(getPosition(existingUser)), selectedPositions = _b[0], setSelectedPositions = _b[1];
    var _c = React.useState(getNoEller(existingUser)), isElller = _c[0], setIsEller = _c[1];
    var _d = React.useState(getIsSfct(existingUser)), isSFCT = _d[0], setIsSFCT = _d[1];
    var _e = React.useState(getIsNoSmallBoat(existingUser)), isNoSmallBoat = _e[0], setIsNoSmallBoat = _e[1];
    var timesRemaining = useSelector(function (state) { return state.user.timesRemaining; });
    var isDraftUpdated = useSelector(function (state) { return state.user.isDraftUpdated; });
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                closeModal();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [closeModal]);
    var closeModalHandle = function () {
        closeModal();
    };
    var addNameAction = function (isEdit) {
        if (selectedPositions.length === 0) {
            toast.error('Please select at least one position');
            return;
        }
        handleSubmit(selectedPositions, isElller, isSFCT, isNoSmallBoat, isEdit);
    };
    var _f = useAddNameToList(), loading = _f.loading, addNameToList = _f.addNameToList;
    var handleSubmit = function (selectedPositions, isElller, isSFCT, isNoSmallBoat, isEdit) { return __awaiter(void 0, void 0, void 0, function () {
        var addNameToListPayload, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    addNameToListPayload = {
                        position: selectedPositions.map(function (position) { return ({ key: position, value: position }); }),
                        not_eller: isElller ? 'on' : '',
                        not_sfct: isSFCT ? 'on' : '',
                        not_small: isNoSmallBoat ? 'on' : '',
                        user_id: userId,
                        isEdit: isEdit
                    };
                    return [4 /*yield*/, addNameToList(addNameToListPayload)];
                case 1:
                    response = _a.sent();
                    if (response.status === 'success') {
                        if (isDraftUpdated === 0) {
                            updateLocalStorageAttribute('times_remaining', timesRemaining - 1);
                            dispatch(updateUserState({ key: 'timesRemaining', value: timesRemaining - 1 }));
                        }
                        addNameHandle();
                    }
                    else {
                        toast.error(response.error);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { ref: modalRef, className: "absolute flex-1 top-0 right-0 left-0 z-10 justify-center px-4", children: [_jsx(ToastContainer, { position: 'top-right' }), _jsxs("div", { className: "bg-white my-12 relative w-full lg:w-[40%] lg:mx-auto rounded-xl border-[#00000014] outline-none p-4 opacity-100 shadow-[0_8px_12px_0_rgba(47,43,67,0.2)] border-t-[1px] border-t-[rgba(47,43,67,0.1)]", children: [_jsx("button", { onClick: function () { return closeModalHandle(); }, className: "text-slate-700 absolute top-[12px] right-[12px]", children: _jsx("img", { src: icons.closeBlack, alt: "" }) }), _jsx("div", { className: "mt-2", children: _jsxs("h3", { className: "text-left text-[18px] font-semibold", children: [!existingUser ? 'Add ' : 'Edit ', " your name in the chase list"] }) }), _jsxs("div", { className: "my-4 ", children: [_jsx("label", { htmlFor: "email", className: "mb-3 text-[15px] font-[500]", children: "Select Positions(s)" }), _jsx("div", { className: "mt-2", children: _jsx("select", { className: "w-full py-2 border border-[#00000014] outline-none rounded-md", onChange: function (e) {
                                        var selected = Array.from(e.target.selectedOptions, function (option) { return option.value; });
                                        setSelectedPositions(Array.from(new Set(__spreadArray(__spreadArray([], selectedPositions, true), selected, true))));
                                    }, children: positions.map(function (position, index) {
                                        if (selectedPositions.includes(position.key)) {
                                            return null;
                                        }
                                        return _jsx("option", { value: position.key, children: position.value }, index);
                                    }) }) }), _jsx("div", { className: "mt-2 flex item-center justify-start gap-2 overflow-x-auto", children: selectedPositions.map(function (position, index) { return (_jsx(PrimaryButton, { title: position, classes: "bg-[#5898FD] text-white py-1 px-3 text-xs", icon: icons.checkWhite, iconPosition: "right", clickHandle: function () {
                                        return setSelectedPositions(selectedPositions.filter(function (item) { return item !== position; }));
                                    } }, index)); }) })] }), _jsxs("div", { children: [_jsx(PrimaryButton, { title: "I cannot work with Eller", classes: "text-black px-3 rounded-[10px] bg-white w-full border border-[#00000014] justify-between py-2", icon: isElller ? icons.checkblueCircle : icons.circle, iconPosition: "right", clickHandle: function () { return setIsEller(!isElller); } }), _jsx(PrimaryButton, { title: "I cannot work with SFCT", classes: "mt-3 text-black px-3 rounded-[10px] bg-white w-full border border-[#00000014] justify-between py-2", iconPosition: "right", icon: isSFCT ? icons.checkblueCircle : icons.circle, clickHandle: function () { return setIsSFCT(!isSFCT); } }), _jsx(PrimaryButton, { title: "No Small Boat/Dust bowl", classes: "mt-3 text-black px-3 rounded-[10px] bg-white w-full border border-[#00000014] justify-between py-2", iconPosition: "right", icon: isNoSmallBoat ? icons.checkblueCircle : icons.circle, clickHandle: function () { return setIsNoSmallBoat(!isNoSmallBoat); } })] }), _jsx("div", { className: "my-4", children: loading ? (_jsx(Spinner, {})) :
                            (_jsx(PrimaryButton, { title: "".concat(existingUser ? 'Update' : 'Add', " Name"), classes: "bg-[#5898FD] text-white w-full py-2", clickHandle: function () { return addNameAction(existingUser ? true : false); } })) })] })] }));
};
export default AddNameToListModal;
